function load() {
  var container =  document.getElementById("container");
  var ban = document.getElementById("ban");
  var banner = document.getElementById("banner");
  var li = document.querySelectorAll("#banner li");
  var spanNode = document.querySelectorAll("#buttons span");
  var text = document.getElementsByClassName("text")[0];

  var prev = document.getElementById('prev');
  var next = document.getElementById('next');

  var index = 1;

  var timer = 0;

  banner.style.height = text.offsetHeight + "px";
  banner.style.width = text.offsetWidth * li.length + 30 * (li.length - 1) + "px";

  function animate(offset) {
  banner.style.transition = "0.5s";
    banner.style.left = -parseInt(offset )* index + "px";
  }

  next.onclick = function () {
    if(index == spanNode.length){
      index = 0;
    }
    index ++;

    animate(text.offsetWidth)
    showButton()
  }

  prev.onclick = function () {
    if(index == 1){
      index = li.length-1;
    }
    index--;
    animate(text.offsetWidth)
    showButton()
  }


  function showButton() {
    for (var i = 0; i< spanNode.length; i++){
      spanNode[i].className = '';
    }
    spanNode[index-1].className = "on";
  }



  function play() {
    timer = setInterval(function () {
      banner.style.transition = "none";
      setTimeout(function () {
        next.onclick();
      },200)
    },1500);
  }

  container.onmouseover = function () {
    clearInterval(timer);
  }
  container.onmouseout = function () {
    play()
  }

  function ButtonImage() {
    for (var i = 0; i< spanNode.length; i++){
      spanNode[i].onclick = function () {
        var myIndex = parseInt(this.getAttribute('index'));
        index = myIndex;
        animate(text.offsetWidth);
        showButton();
      }
    }
  }
  ButtonImage()
}

export {
  load
}


// WEBPACK FOOTER //
// ./src/views/promotion/lp/ReviewText.js